export const COMPANY_SECTORS = [
  'Fiduciaire & Comptabilité',
  'Design & Créatif',
  'Informatique & Tech',
  'BTP & Construction',
  'Marketing & Publicité',
  'Ressources Humaines',
  'Transport & Déménagement',
  'Services aux entreprises',
  'Architecture & Urbanisme',
  'Assurance & Prévoyance',
  'Automobile & Mobilité',
  'Banque & Finance',
  'Chimie & Pharmacie',
  'Commerce de détail',
  'Communication & PR',
  'Conseil & Stratégie',
  'Distribution & Logistique',
  'Droit & Juridique',
  'E-commerce',
  'Éducation & Formation',
  'Energie & Environnement',
  'Hôtellerie & Restauration',
  'Immobilier',
  'Import & Export',
  'Imprimerie & Édition',
  'Industrie & Manufacturing',
  'Luxe & Horlogerie',
  'Médias & Presse',
  'Médical & Clinique',
  'Nettoyage & Facility',
  'Optique & Lunetterie',
  'Santé & Bien-être',
  'Sanitaire & Plomberie',
  'Sécurité & Surveillance',
  'Sport & Loisirs',
  'Telecommunications',
  'Textile & Mode',
  'Tourisme & Voyages',
  'Agriculture & Viticulture',
  'Arts & Culture',
  'Autre',
]
